/**
 * O contador no título da aba — parte D1 (01/10/2026), spec §6.3.
 *
 * "(N) SE_WEB — Sistema Corporativo": N = avisos que apareceram com a aba oculta ou sem
 * interação há mais de 30 s. Zera no 1º clique/tecla com a aba visível. Não é o total
 * de não lidas: só 3 de 65 notificações foram lidas na produção — "(62)" fixo seria ruído.
 */

export const OCIOSO_MS = 30_000;

let contador = 0;
let ultimaInteracao = Date.now();
let tituloBase: string | null = null;

function abaVisivel(): boolean {
  return typeof document === "undefined" || document.visibilityState === "visible";
}

const COM_CONTADOR = /^\(\d+\+?\)\s*/;

function aplicar(): void {
  if (typeof document === "undefined" || tituloBase === null) return;
  document.title =
    contador > 0 ? `(${contador > 99 ? "99+" : contador}) ${tituloBase}` : tituloBase;
}

/** Um aviso apareceu: conta se a pessoa não está olhando. */
export function contarAvisoNoTitulo(agora: number = Date.now()): void {
  if (abaVisivel() && agora - ultimaInteracao <= OCIOSO_MS) return;
  // Desenho do portal 0.8: a base é lida TODA vez que o contador sai de zero, não só na primeira. O título da página muda
  // entre uma contagem e outra (o portal troca o do index.html ao entrar em /portal): uma base guardada da vez anterior
  // reescreveria o título antigo.
  if (contador === 0 && typeof document !== "undefined") {
    tituloBase = document.title.replace(COM_CONTADOR, "");
  }
  contador += 1;
  aplicar();
}

/** Clique ou tecla: a pessoa voltou. */
export function registrarInteracao(agora: number = Date.now()): void {
  ultimaInteracao = agora;
  if (contador > 0 && abaVisivel()) {
    contador = 0;
    aplicar();
  }
}

/** Devolve o título original (sair da sessão, desmontar o provider). */
export function zerarTitulo(): void {
  if (contador === 0) return;
  contador = 0;
  aplicar();
}

/** Só para os testes. */
export function _reiniciarTituloParaTeste(agora: number = Date.now()): void {
  contador = 0;
  ultimaInteracao = agora;
  tituloBase = null;
}
